export default "/images/img-4.jpg?d54eed02ef5a376c9b2b46f9f02a4ec4";